'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _create = require('babel-runtime/core-js/object/create');

var _create2 = _interopRequireDefault(_create);

var _setPrototypeOf = require('babel-runtime/core-js/object/set-prototype-of');

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _from = require('babel-runtime/core-js/array/from');

var _from2 = _interopRequireDefault(_from);

var _construct = require('babel-runtime/core-js/reflect/construct');

var _construct2 = _interopRequireDefault(_construct);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _constants = require('../constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extendableBuiltin(cls) {
  function ExtendableBuiltin() {
    var instance = (0, _construct2.default)(cls, (0, _from2.default)(arguments));
    (0, _setPrototypeOf2.default)(instance, (0, _getPrototypeOf2.default)(this));
    return instance;
  }

  ExtendableBuiltin.prototype = (0, _create2.default)(cls.prototype, {
    constructor: {
      value: cls,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });

  if (_setPrototypeOf2.default) {
    (0, _setPrototypeOf2.default)(ExtendableBuiltin, cls);
  } else {
    ExtendableBuiltin.__proto__ = cls;
  }

  return ExtendableBuiltin;
}

/**
 * Extended Error object to signify the intent to join for unclaimed PMR scenarios
 */
var IntentToJoinError = function (_extendableBuiltin2) {
  (0, _inherits3.default)(IntentToJoinError, _extendableBuiltin2);

  /**
  *
  * @param {Object} error
  * @param {String} message
  * @returns {Error}
  */
  function IntentToJoinError(error) {
    var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _constants.ERROR_DICTIONARY.INTENT_TO_JOIN.MESSAGE;
    (0, _classCallCheck3.default)(this, IntentToJoinError);

    var _this = (0, _possibleConstructorReturn3.default)(this, (IntentToJoinError.__proto__ || (0, _getPrototypeOf2.default)(IntentToJoinError)).call(this, message));

    _this.name = _constants.ERROR_DICTIONARY.INTENT_TO_JOIN.NAME;
    _this.sdkMessage = _constants.ERROR_DICTIONARY.INTENT_TO_JOIN.MESSAGE;
    _this.error = error;
    _this.joinIntentRequired = true;
    _this.code = _constants.ERROR_DICTIONARY.INTENT_TO_JOIN.CODE;
    return _this;
  }

  return IntentToJoinError;
}(_extendableBuiltin(Error));

exports.default = IntentToJoinError;
//# sourceMappingURL=intent-to-join.js.map
